import { FormControl, FormHelperText, FormLabel, Grid, Box } from '@mui/material';
import React, { FC } from 'react';

export interface IProps {
	id?: string;
	name?: string;
	error?: boolean;
	helperText?: string | false;
	label: string | React.JSX.Element;
	labelAlign?: string;
	subText?: React.ReactNode | string;
	topLabel?: boolean;
	children: React.ReactNode;
	fillWidth?: boolean;
	helperTextColour?: string;
	noMarginBottom?: boolean;
}

const FormField: FC<IProps> = ({
	error,
	helperText,
	id,
	name,
	label,
	children,
	labelAlign = 'center',
	subText,
	topLabel,
	fillWidth,
	helperTextColour,
	noMarginBottom,
}) => {
	return (
		<FormControl
			name={name}
			error={error}
			fullWidth
			component='fieldset'
			sx={(theme) => ({
				pr: fillWidth ? 'unset' : '20%',
				pl: topLabel ? '20%' : 'unset',
				flexDirection: 'column',
				justifyContent: 'space-around',
				mb: noMarginBottom ? 0 : 3,
				'& .MuiOutlinedInput-root': {
					'&.Mui-focused fieldset': {
						border: '1.5px solid rgba(0, 0, 0, 0.87)',
					},
				},
				[theme.breakpoints.down('md')]: {
					pr: 'unset',
					pl: 'unset',
				},
			})}
		>
			<Grid container direction='row' alignItems={labelAlign} spacing={2} justifyContent='center' alignContent='center'>
				<Grid
					size={{ xs: 12, md: topLabel ? 12 : 4 }}
					sx={(theme) => ({
						textAlign: { md: 'right' },
						[theme.breakpoints.down('md')]: { textAlign: 'left' },
					})}
				>
					<Box
						sx={{
							'& .MuiFormLabel-root.Mui-focused': {
								color: 'black',
							},
						}}
					>
						<FormLabel htmlFor={id}>{label}</FormLabel>
						{subText}
					</Box>
				</Grid>

				{fillWidth ? (
					<Grid size={12}>{children}</Grid>
				) : (
					<Grid size={{ xs: 12, md: topLabel ? 12 : 8 }}>{children}</Grid>
				)}
				<Grid size={12}>
					<FormHelperText
						sx={(theme) => ({
							color: helperTextColour ?? 'black',
							marginLeft: '35%',
							marginRight: 'auto',
							[theme.breakpoints.down('md')]: {
								marginLeft: 'unset',
								marginRight: 'unset',
								paddingLeft: 2,
							},
						})}
						id={`${id ?? ''}-helper-text`}
					>
						{helperText}
					</FormHelperText>
				</Grid>
			</Grid>
		</FormControl>
	);
};

export default FormField;
